<script>
import { required } from 'vuelidate/lib/validators'
import { chars } from '@state/modules/chars'
import { cepApi } from '@router/apiFiles/cepApi'


export default {
	data() {
		return {
			states: [ 'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO' ],
        	address_street: '',
        	address_city: '',
        	address_state: '',
        	address_zipcode: '',
        	address_neighborhood: '',
			address_number: '',
			address_complement: ''
		}
	},
	validations: {
		address_street: { required },
		address_city: { required },
		address_state: { required },
		address_zipcode: { required },
		address_neighborhood: { required },
		address_number: { required },
		address_complement: { },
		form: ['address_street', 'address_city', 'address_state', 'address_zipcode', 'address_neighborhood', 'address_number', 'address_complement' ],
	},
	methods: {
		...chars,
		validate() {
			this.$v.form.$touch()
			var isValid = !this.$v.form.$invalid
			this.$emit('on-validate', this.$data, isValid)
			return isValid
		},
		searchCep() {
			var self = this;
			if(self.address_zipcode.length >= 8) {
				cepApi.getAddress({cep: self.address_zipcode})
				.then(function(data) {
					self.address_street = data.logradouro;
					self.address_city = data.localidade;
					self.address_state = data.uf;
					self.address_neighborhood = data.bairro;
				});
			}
		}
	},
}
</script>

<template>
	<div>
	
		<h4 class="header-title mt-0 mb-1">Endereço para resgate dos produtos</h4>
		<br />

		<div class="row">
			<div class="col-md-4">
				<b-form-group label="CEP">
					<b-form-input
						v-model.trim="address_zipcode"
						:class="{ 'is-invalid': $v.address_zipcode.$error }"
						type="text"
						v-model="address_zipcode"
						v-mask="'#####-###'"
						v-on:keyup="searchCep"
						placeholder="Informe o CEP"
					></b-form-input>
					<span v-if="$v.address_zipcode.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>		
		</div>

		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Rua">
					<b-form-input
						v-model.trim="address_street"
						:class="{ 'is-invalid': $v.address_street.$error }"
						type="text"
						placeholder="Informe a rua"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent												
					></b-form-input>
					<span v-if="$v.address_street.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="Número">
					<b-form-input
						v-model.trim="address_number"
						:class="{ 'is-invalid': $v.address_number.$error }"
						type="text"
						placeholder="Informe o numero"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent												
					></b-form-input>
					<span v-if="$v.address_number.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	

		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Bairro">
					<b-form-input
						v-model.trim="address_neighborhood"
						:class="{ 'is-invalid': $v.address_neighborhood.$error }"
						type="text"
						placeholder="Informe o bairro"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.address_neighborhood.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>

		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Cidade">
					<b-form-input
						v-model.trim="address_city"
						:class="{ 'is-invalid': $v.address_city.$error }"
						type="text"
						placeholder="Informe a cidade"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.address_city.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<div class="form-group mt-3 mt-sm-0">
					<label for="Estado">Estado</label>
					<b-form-select v-model="address_state" class="mb-2" :options="states" v-model.trim="address_state" :class="{ 'is-invalid': $v.address_state.$error }"></b-form-select>
				</div>
			</div>
		</div>
		
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Complemento">
					<b-form-input
						v-model.trim="address_complement"
						type="text"
						placeholder="Informe o complemento"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
				</b-form-group>
			</div>
		</div>

	</div>
</template>
